import { TranslateFunction } from "@made-people/grease-translations";

export type StockStatusResult = {
  deliveryStatus: string;
  isImmediateDelivery: boolean;
};

export function getStockStatus(
  args: {
    discontinued: boolean;
    warehouseIds: string[];
    virtualWarehouseId: string | undefined;
    stockByWarehouse: Record<string, number>;
  },
  translate: TranslateFunction,
): StockStatusResult {
  const realWarehouseIds = args.virtualWarehouseId
    ? args.warehouseIds.filter((id) => id !== args.virtualWarehouseId)
    : args.warehouseIds;

  for (const warehouseId of realWarehouseIds) {
    if ((args.stockByWarehouse[warehouseId] ?? 0) > 0) {
      return {
        deliveryStatus: translate("Delivery_In_Stock"),
        isImmediateDelivery: true,
      };
    }
  }

  if (
    args.virtualWarehouseId &&
    (args.stockByWarehouse[args.virtualWarehouseId] ?? 0) > 0
  ) {
    return {
      deliveryStatus: translate("Delivery_In_Stock_Virtual"),
      isImmediateDelivery: true,
    };
  }

  if (args.discontinued) {
    return {
      deliveryStatus: translate("Delivery_Out_Of_Stock"),
      isImmediateDelivery: false,
    };
  }

  return {
    deliveryStatus: translate("Delivery_Temporarily_Out_Of_Stock"),
    isImmediateDelivery: false,
  };
}
